export default __webpack_public_path__ + "navigation-examples-basic-thumbnail-v1-960-403cee4ee0cf00a18f3ccc0f54ebcf26.png";